import { createContext, useContext, useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import en from "../locales/en.json";
import es from "../locales/es.json";
import { setLanguage } from "../redux/Slices/Language";

const TranslationContext = createContext();

const languages = { en, es };

export const TranslationProvider = ({ children }) => {
  const dispatch = useDispatch();

  const [lang, setLang] = useState(localStorage.getItem("lang") || "en");
  const [translations, setTranslations] = useState(languages[lang]);

  useEffect(() => {
    setTranslations(languages[lang]);
    dispatch(setLanguage(lang));
  }, [lang, dispatch]);

  const t = (key, params = {}) => {
    const keys = key.split(".");
    let value = translations;
    for (const k of keys) value = value?.[k];
    if (typeof value !== "string") return value || key;

    return value.replace(/{{\s*(\w+)\s*}}/g, (placeholder, name) =>
      Object.prototype.hasOwnProperty.call(params, name)
        ? String(params[name])
        : placeholder,
    );
  };

  const changeLang = (newLang) => {
    localStorage.setItem("lang", newLang);
    setLang(newLang);
    dispatch(setLanguage(newLang));
  };

  return (
    <TranslationContext.Provider value={{ t, lang, setLang: changeLang }}>
      {children}
    </TranslationContext.Provider>
  );
};

export const useTranslate = (prefix) => {
  const { t: baseT, lang, setLang } = useContext(TranslationContext);

  const t = (key, params) => {
    if (!prefix) return baseT(key, params);
    if (prefix.includes(".")) return baseT(prefix, params);
    return baseT(`${prefix}.${key}`, params);
  };

  return { t, lang, setLang };
};
